import React, { useState, useEffect } from "react";
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import { Link } from 'react-router-dom';
import axios from 'axios';
import Swal from 'sweetalert2';
import {baseUrl, userLocation, ipAddress, userName, formatDateTime} from '../Univ.js'
function AddBank() {

  const [errorMsg, seterrorMsg] = useState('');
  const [rows, setRows] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [cons,setCons] = useState([]);
  const [consdept,setConsDept] = useState([]);

  const [succesMsg, setsuccessMsg] = useState('');
  const [registerFormData, setRegisterFormData] = useState({
        "bank":'',
        "branch":'',
        "ifsc":'',
        "account":'',
        "acc_no":'',
        "acc_type":'',
        "balance":'',
        "status":'',
        "addedby":'',
        "ip_add":'',
    });
  const inputHandler = (event) => {
        setRegisterFormData({
            ...registerFormData,
            [event.target.name]:event.target.value
        })
  };

  const submitHandler = (e) => {
     e.preventDefault();
        const formData = new FormData();
        const acc_type = document.getElementById("acc_type").value;
        formData.append('bank',registerFormData.bank);
        formData.append('branch',registerFormData.branch);
        formData.append('ifsc',registerFormData.ifsc);
        formData.append('account',registerFormData.account);
        formData.append('acc_no',registerFormData.acc_no);
        formData.append('acc_type',acc_type);
        formData.append('balance',registerFormData.balance);
        formData.append('status', '1');
        formData.append('addedby', userName);
        formData.append('ip_add', ipAddress);
          formData.append('location', userLocation);

        axios.post(baseUrl+'add-bank/', formData)
          .then((response) => {
              if(response.status==200 || response.status==201){
                Swal.fire({
                  title: 'Bank has been added.',
                  icon: 'success',
                  timer: 5000,
                  showConfirmButton: false
                });
                setTimeout(() => {
                  window.location.href = '/add-bank/';
                }, 3000);
              }
            })
              .catch(error => {
              console.log(error);
                  Swal.fire(
                    'Error!',
                    'Failed to add bank. Please try again later.',
                    'error'
                  );
              });            
  };
  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
      if (cons.length > 0) {
        setRows(cons);
      }
  }, [cons]);
  function fetchData() {
    setIsLoading(true);
    axios.get(`${baseUrl}add-bank/`)
      .then(response => {
        setCons(response.data);
        setIsLoading(false);
      })
      .catch(error => {
        console.log(error);
        setIsLoading(false);
      });
  }
    const handleDelete = (id) => {
        Swal.fire({
            title: 'Confirm',
            text: 'Are you Sure you want to delete this',
            icon: 'info',
            confirmButtonText: 'Continue',
            showCancelButton: true
        }).then((result)=>{
            if(result.isConfirmed){
               try{
                   axios.delete(baseUrl+'delete-bank/'+id)
                   .then(function (response) {
                      Swal.fire('success', 'Data has been Deleted');
                      window.location.reload();
                    });
               }catch(error){
                    Swal.fire('error', 'Data has not been deleted');
               }
            }else{
                  Swal.fire('error', 'Data has not been deleted');
            }

        })
    }
  const columns = [
    { field: 'id', headerName: 'Id', width: 50 },
    { field: 'bank', headerName: 'Bank Name', width: 120 },
    { field: 'branch', headerName: 'Branch', width: 150 },
    { field: 'ifsc', headerName: 'IFSC', width: 120 },
    { field: 'account', headerName: 'Account Name', width: 150},
    { field: 'acc_no', headerName: 'Acc No', width: 180},
    { field: 'acc_type', headerName: 'Acc Type', width: 120},
    { field: 'balance', headerName: 'Balance Amount', width: 160},
      { field: 'delete', headerName: 'Action',
        renderCell: (params) => (
          <button onClick={()=> handleDelete(params.row.id)} className="btn btn-danger btn-sm ms-1">
          <i className="fa-solid fa-trash-can"></i></button>
      ),
      width: 100 },

  ];

    const buttonEnable = (registerFormData.consultant!='') && (registerFormData.specialization!='') && (registerFormData.mobile!='')
  return (
        <section className="container mt-4">
            <div className="row">
              <div className="col-md-8 col-12">
                <div className='card'>
                    <h4 className='card-header text-center'>Add Bank</h4>
                    <div className='card-body'>
                        <p className="text-muted"><strong>Note:</strong>All are Mandatory Fields</p>
                        {succesMsg && <p className="text-success">{succesMsg}</p>}
                        {errorMsg && <p className="text-danger">{errorMsg}</p>}
                        <form>
                        <div className="row">
                        <div className="col-md-6 mb-3">
                        <label htmlFor="Consultant" className="form-label">Bank Name</label>
                            <input type="text" placeholder="Bank Name" className="form-control"
                               name="bank" value={registerFormData.bank} onChange={inputHandler} />
                        </div>
                        <div className="col-md-6 mb-3">
                            <label htmlFor="branch" className="form-label">Branch</label>
                            <input type="text" placeholder="Branch" className="form-control"
                               name="branch" value={registerFormData.branch} onChange={inputHandler} />
                        </div>
                        </div>
                        <div className="row">
                        
                        <div className="col-md-6 mb-3">
                            <label htmlFor="Fees" className="form-label">IFSC Code</label>
                            <input type="text" maxLength={10} placeholder="IFSC" className="form-control"
                                name="ifsc" value={registerFormData.ifsc} onChange={inputHandler} />
                        </div>
                        <div className="col-md-6 mb-3">
                            <label htmlFor="account" className="form-label">Account Name</label>
                            <input type="text" maxLength={20} placeholder="Account Name" className="form-control"
                                name="account" value={registerFormData.account} onChange={inputHandler} />
                        </div>
                        </div>
                        <div className="row">
                        <div className="col-md-4 mb-3">
                            <label htmlFor="Account No" className="form-label">Account Number</label>
                            <input type="text" maxLength={20} placeholder="Account No" className="form-control"
                                name="acc_no" value={registerFormData.acc_no} onChange={inputHandler} />
                        </div>

                        <div className="col-md-4 mb-3">
                        <label htmlFor="acc_type" className="form-label">Account Type</label>
                            <select className="form-control" value={registerFormData.acc_type} onChange={inputHandler}
                              name="acc_type" id="acc_type">
                              <option >Select</option>
                            <option value="Current">Current</option>
                            <option value="Other">Other</option>
                            </select>
                        </div>
                        <div className="col-md-4 mb-3">
                            <label htmlFor="Account Balance" className="form-label">Current Balance</label>
                            <input type="number" maxLength={20} placeholder="Account Balance" className="form-control"
                                name="balance" value={registerFormData.balance} onChange={inputHandler} />
                        </div>
                        </div>
                        <div className="row">
                        <div className="col-md-12 text-center">
                        <button type="button" disabled={!buttonEnable} onClick={submitHandler}
                        className="btn btn-success">Register</button>
                        </div>
                        </div>
                        </form>
                    </div>
                </div>
              </div>
            </div>
            <div style={{ height: "100%", width: "100%" }}>
          <DataGrid className="mt-4"
            sx={{
              boxShadow: 4,
              border: 4,
              borderColor: 'primary.light',
              '& .MuiDataGrid-cell:hover': {
                color: 'primary.main',
              },
            }}
            pageSize={28}
            rows={rows}
            columns={columns}
            components={{
                Toolbar: GridToolbar,
             }}
            autoHeight
          />
          </div>
        </section>
  );
}

export default AddBank;
